import getMembershipProperties from './getMembershipProperties'

export default function getMembershipId() {
  const { id } = getMembershipProperties()

  return id
}
